import { showError } from "utils/notifications";

// Reusable room enrichment function
export const enrichRoom = (room, typeDetails, roomOffer, values) => {
    if (!typeDetails) return room;

    return {
        ...room,
        extra_bed_charge: typeDetails.extra_bed_charge ?? room.extra_bed_charge ?? 0,
        extra_person_charge: typeDetails.extra_person_charge ?? room.extra_person_charge ?? 0,
        extra_child_charge: typeDetails.extra_child_charge ?? room.extra_child_charge ?? 0,
        capacity: typeDetails.capacity ?? room.capacity ?? 0,
        extra_Capablity: typeDetails.exbed_capability ?? room.exbed_capability,
        exbed_capability_limit: typeDetails?.exbed_capability_limit ?? room.exbed_capability_limit ?? 0,
        room_offer: roomOffer?.room_offer ?? room.room_offer ?? 0,
        offer_title: roomOffer?.offer_title ?? room.offer_title ?? '',
        offer_id: roomOffer?.offer_id ?? room.offer_id ?? 0
    };
};

// Disable specific fields in a field array
export const disableFields = (fields, fieldNames) => {
    return fields?.map(field => {
        if (fieldNames.includes(field.name)) {
            return { ...field, disabled: true };
        }
        return field;
    });
};

export const percentOf = (percent, amount) =>
    (Number(percent || 0) * Number(amount || 0)) / 100;

export const normalizeCustomerOption = (option) => {
    if (!option) return null;

    const fd = option.fullData || {};
    const id = option.value || fd.customer_id || fd.id || fd.customerId;
    const full_name = fd.full_name || fd.name || option.label || "";
    const phone = fd.name?.split("-")[0] || "";

    return id ? { customer_id: String(id), full_name, phone } : null;
};

export const fetchOptions = async (fetchFn, id, setter) => {
    if (!id) return;
    const res = await fetchFn(id);
    setter(res.data || []);
};

// ---------------------- OPTIONS BUILDER ----------------------

export const RoomFieldsOpction = (
    field,
    room,
    roomTypesOption,
    roomNumbersByType,
    selectedRoomIds
) => {

    if (field === "room_id") {
        return roomTypesOption.map(({ room_id, room_type }) => ({
            value: room_id,
            label: room_type
        }));
    }

    if (field === "room_no") {
        let rooms = [...(roomNumbersByType?.[room?.room_id] || [])];

        // Ensure current room exists in the list
        const exists = rooms.some(
            (r) => r.room_id === room.room_no
        );

        if (!exists && room?.room_no) {
            rooms.push({
                room_id: room.room_no,
                room_no: room.room_no
            });
        }

        return rooms
            .filter(
                (r) =>
                    !selectedRoomIds.includes(r.room_id) ||
                    r.room_id === room.room_no
            )
            .map(({ room_id, room_no }) => ({
                value: room_id,
                label: room_no
            }));
    }
};

export const handleConfirm = (
    selectedCustomerId,
    selectedCustomer,
    customerType,
    setExistingCustomers,
    setValues,
    newCustomer,
    setShow,
    setSelectedCustomer
) => {
    if (customerType === "existing") {
        if (!selectedCustomerId) return showError("Please select a customer");

        setExistingCustomers((prev) => {
            const exists = prev.some((c) => String(c.customer_id) === String(selectedCustomerId));
            if (exists) return prev;
            return selectedCustomer?.customer_id ? [...prev, selectedCustomer] : prev;
        });

        setValues((prev) => ({ ...prev, customer_id: selectedCustomerId }));
    }

    if (customerType === "new") {
        if (!newCustomer.name || !newCustomer.phone) {
            alert("Please enter all fields");
            return;
        }
    }
    setShow(false);
};

// helpers/customerHelpers.js
export const deleteCustomerHelper = ({
    customerId,
    setExistingCustomers,
    setValues,
    selectedCustomerId,
    setSelectedCustomerId
}) => {

    const id = String(customerId);

    setExistingCustomers(prev =>
        prev.filter(c => String(c.customer_id) !== id)
    );

    setValues(prev => ({
        ...prev,
        customer_id: String(prev.customer_id) === id ? "" : prev.customer_id
    }));

    if (String(selectedCustomerId) === id) {
        setSelectedCustomerId("");
    }
};


